import { IGeoMarketApi } from '../api/types'
import { IGeoMarket } from '../model/types'

export const mapGeoMarketFromApi = (data: IGeoMarketApi): IGeoMarket => ({
  name: data.GeoMarket,
  order: data.GeoMarketOrder,
  short: data.GeoMarketShort,
})
